import React, { useState } from 'react';
import RedeemService from '../../../services/redeem.service';

const s = {
  title: { fontSize: 18, fontWeight: 600, marginBottom: 6, color: '#e2e2f0' },
  sub: { fontSize: 13, color: '#888', marginBottom: 24 },
  label: { display: 'block', fontSize: 12, fontWeight: 500, color: '#aaa', marginBottom: 6 },
  input: {
    width: '100%',
    background: '#0f0f1a',
    border: '1px solid #2a2a40',
    borderRadius: 10,
    padding: '12px 16px',
    fontSize: 14,
    color: '#e2e2f0',
    outline: 'none',
    letterSpacing: '0.05em',
    boxSizing: 'border-box',
  },
  inputFocus: { borderColor: '#7c3aed' },
  error: { fontSize: 11, color: '#f87171', marginTop: 6 },
  btnPrimary: {
    width: '100%',
    background: '#7c3aed',
    color: 'white',
    border: 'none',
    borderRadius: 10,
    padding: '13px 0',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 20,
    transition: 'background 0.2s',
    textAlign: 'center',
  },
};

export default function Step1Coupon({ wizard }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [focused, setFocused] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const code = wizard.couponCode.trim().toUpperCase();
    if (!code) { setError('Ingresa tu codigo de cupon.'); return; }
    setLoading(true);
    setError('');
    try {
      const data = await RedeemService.previewCoupon(code);
      wizard.setTemplateData(data);
      wizard.goToStep(2);
    } catch (err) {
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail || {};
      const code = typeof detail === 'object' ? detail.code : '';
      const msg = typeof detail === 'string' ? detail.toLowerCase() : '';
      if (status === 404 || status === 422) {
        if (code === 'INVALID_ACTIVATION_CODE' || msg.includes('redeemed') || msg.includes('already')) {
          setError('Cupon invalido o expirado.');
        } else {
          setError('Cupon invalido o expirado.');
        }
      } else {
        setError('Error de conexion. Intenta nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div style={s.title}>Ingresa tu cupon</div>
      <div style={s.sub}>Recibiras acceso a un template configurado para tu industria.</div>
      <label style={s.label}>Codigo de cupon</label>
      <input
        type="text"
        value={wizard.couponCode}
        onChange={(e) => wizard.setCouponCode(e.target.value.toUpperCase())}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder="ej. ECOMMERCE-2024"
        disabled={loading}
        style={{ ...s.input, ...(focused ? s.inputFocus : {}), opacity: loading ? 0.5 : 1 }}
      />
      {error && <div style={s.error}>{error}</div>}
      <button
        type="submit"
        disabled={loading}
        style={{ ...s.btnPrimary, opacity: loading ? 0.6 : 1 }}
        onMouseEnter={(e) => { e.target.style.background = '#6d28d9'; }}
        onMouseLeave={(e) => { e.target.style.background = '#7c3aed'; }}
      >
        {loading ? 'Validando...' : 'Validar cupon'}
      </button>
    </form>
  );
}
